import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckoutNequiFormContainerComponent } from './components/checkout-nequi-form-container/checkout-nequi-form-container.component';
@Component({
  selector: 'angular-monorepo-checkout-form-nequi',
  standalone: true,
  imports: [CommonModule, CheckoutNequiFormContainerComponent],
  templateUrl: './checkout-form-nequi.component.html',
  styleUrl: './checkout-form-nequi.component.scss',
})
export class CheckoutFormNequiComponent {}
